<main>
    <div class="flex">
        <app-menu></app-menu>
        <aside *ngIf="!item && loadingItem === false" aria-label="not-found">
            <header>
                <div>
                    <h1 *ngIf="item.itemType === itemTypeEnum.Trainingen">Training niet gevonden</h1>
                    <h1 *ngIf="item.itemType === itemTypeEnum.KennisCafe">Kenniscafé item niet gevonden</h1>
                </div>
            </header>
            <section *ngIf="item.itemType === itemTypeEnum.Trainingen">
                <div>
                    <h2>Oeps, de training die je probeert te openen bestaat niet.</h2>
                </div>
                <div>
                    <app-button class="filled-primary" routerLink="/trainingen">Bekijk alle trainingen</app-button>
                </div>
            </section>
            <section *ngIf="item.itemType === itemTypeEnum.KennisCafe">
                <div>
                    <h2>Oeps, het Kenniscafé die je probeert te openen bestaat niet.</h2>
                </div>
                <div>
                    <app-button class="filled-primary" routerLink="/kenniscafe"
                        >Bekijk alle Kenniscafés</app-button
                    >
                </div>
            </section>
        </aside>
        <aside *ngIf="item && loadingItem === false" aria-label="item-details">
            <header>
                <img *ngIf="base64headerImage" [src]="base64headerImage" alt="Rensa academy event banner" />
                <div>
                    <h1>{{ item?.title }}</h1>
                </div>
            </header>
            <section>
                <div *ngIf="item?.awardsCertificate" class="certificate">
                    <img src="/assets/images/certificate.svg" alt="U ontvangt een certificaat" />
                    <h2 *ngIf="item.itemType === itemTypeEnum.Trainingen">Training met certificaat</h2>
                    <h2 *ngIf="item.itemType === itemTypeEnum.KennisCafe">Kenniscafé met certificaat</h2>
                </div>
                <div class="intro body-text" [innerHTML]="item?.summary"></div>
                <ng-template ngFor let-content [ngForOf]="item?.description">
                    <h2>{{ content.title }}</h2>
                    <div class="normal-text" [innerHTML]="content.content"></div>
                </ng-template>
                <h2 *ngIf="item.itemType === itemTypeEnum.Trainingen">Na de training weet je</h2>
                <h2 *ngIf="item.itemType === itemTypeEnum.KennisCafe">Na het Kenniscafé weet je</h2>
                <ul>
                    <li *ngFor="let learningPoint of item?.learningPoints">
                        <fa-icon [icon]="faCheck"></fa-icon>
                        {{ learningPoint }}
                    </li>
                </ul>
                <h3 *ngIf="item.itemType === itemTypeEnum.Trainingen">Deze training wordt gegeven door:</h3>
                <h3 *ngIf="item.itemType === itemTypeEnum.KennisCafe">Dit kenniscafé wordt gegeven door:</h3>
                <div class="by">
                    <img *ngIf="base64firstHostCompanyImage" [src]="base64firstHostCompanyImage" alt="" />
                    <img *ngIf="base64secondHostCompanyImage" [src]="base64secondHostCompanyImage" alt="" />
                </div>
            </section>
        </aside>
    </div>
</main>
<div class="locations" *ngIf="item && loadingItem === false">
    <section>
        <h2>Locaties</h2>
        <app-event-table
            [events]="item?.events"
            [trainingId]="item?.id"
            [trainingTitle]="item?.title"></app-event-table>
    </section>
</div>
<app-footer
    [showAllEventsButton]="true"
    [contactStyle]="ContactStyle.DETAIL"
    *ngIf="item && loadingItem === false"></app-footer>